module.exports = __webpack_public_path__ + "static/img/banner-02.a7d6b07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner-02.jpg
// module id = jQDJ
// module chunks = 0